import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { DesktopNavigation } from './DesktopNavigation';
import './DesktopSections.css';

export default function DesktopPageFrame({ activePath, theme, ar, title, kicker, actions, className = '', contentAs: Content = 'main', children }) {
  const { currentUserId } = useAuth();
  return <div className={`desktop-app-layout desktop-section-page ${theme === 'dark' ? 'dark' : ''} ${className}`} dir={ar ? 'rtl' : 'ltr'}>
    <DesktopNavigation ar={ar} currentUserId={currentUserId} activePath={activePath} />
    <Content className="desktop-section-workspace">
      <header className="desktop-page-heading"><div><p>{kicker}</p><h1>{title}</h1></div>{actions && <div className="desktop-heading-actions">{actions}</div>}</header>
      {children}
    </Content>
  </div>;
}
